import DangerouslySetHtmlContent from '../subcomponents/DangerouslySetHtmlContent';

export function FreeformRaw({ html }) {
  //return <div dangerouslySetInnerHTML={{ __html: html }} />;
  return <DangerouslySetHtmlContent html={html} />;
}
